// extracted by mini-css-extract-plugin
module.exports = {"select-round":"select-round","btn-select":"btn-select","select-text":"select-text","icon":"icon","round-items":"round-items","round-item":"round-item","is-select":"is-select"};